import React from "react";
import { t } from "../../../../../dev/helpers/translator";
import Config from "../../../../../dev/config/main";
import LanguageSwitcher from "../../../../../dev/terminal/components/languageSwitcher";
import IndexLink from "react-router/es/IndexLink";
import Balance from '../../../../../dev/terminal/components/balance';
import Link from "react-router/es/Link";
import SearchInHeader from "../../../../../dev/terminal/components/searchInheader";
// import { Jackpot } from "../../../../../dev/terminal/containers/jackpot";
// import { JackpotContextProvider } from "../../../../../dev/helpers/jackpot";
import CasinoFavorites from "../../../../../dev/terminal/containers/header/pieces/casinoFavorit";
import OddsSelector from "../../../../../dev/terminal/containers/header/pieces/oddselector";
import NextRacing from "../../../../../dev/terminal/components/nextRacing";

export default function headerTemplate() {
    let { user, location } = this.props,
        userId = user.profile && user.profile.id,
        userName = user.profile && user.profile.username,
        pathName = location.pathname,
        skin = sessionStorage.getItem("authData") && JSON.parse(sessionStorage.getItem('authData')),
        skinType = skin.skinType;
        
    const { pathname } = new URL(window.location.href);
    const [firstPathname] = pathname.substr(1).split('/');

    return <div className={`header-wrapper-t`}>
        <div className="header-container-t">
            <div className="left-column-t">
                <div className="logo-wrapper">

                    {
                        skinType === "casino"
                            ? <IndexLink className="logo-v" activeClassName="active" />
                            : <IndexLink to="/" className="logo-v" activeClassName="active">
                                <p className="over-18">{t("Forbidden to gamble under 18 years of age")}</p>
                              </IndexLink>
                    }
                    {/* <IndexLink to="/" className="logo-v" activeClassName="active"/> */}
                    {skinType !== "casino" && <IndexLink to="/" className="product-item-v home" activeClassName="active" />}
                    {
                        Config.headerItems.filter(item => !item.showOnlyInHome).map((item) => {
                            switch (skinType) {
                                case "sport":
                                    return (item.enabled && item.name === "Live1" || item.name === "Prematch" || item.name === "Top Games" || item.name === "Today" || item.name === "Virtual Games") && <Link to={`/${item.url}`}
                                        className={`product-item-v game  ${item.url}`}
                                        activeClassName="active"
                                        key={item.url}>
                                        {Config.openSectionNameOnClick ? pathName.includes(item.url) && <span>{t(item.name)}</span>
                                            : <span>{t(item.name)}</span>
                                        }
                                    </Link>;
                                case "casino":
                                    return (item.enabled && item.name === "Casino" || item.name === "Live Casino") && <Link to={`/${item.url}`}
                                        className={`product-item-v game  ${item.url}`}
                                        activeClassName="active"
                                        key={item.url}>
                                        {Config.openSectionNameOnClick ? pathName.includes(item.url) && <span>{t(item.name)}</span>
                                            : <span>{t(item.name)}</span>
                                        }
                                    </Link>;
                                default:
                                    return item.enabled && <Link to={`/${item.url}`}
                                        className={`product-item-v game  ${item.url}`}
                                        activeClassName="active"
                                        key={item.url}>
                                        {Config.openSectionNameOnClick ? pathName.includes(item.url) && <span>{t(item.name)}</span>
                                            : <span>{t(item.name)}</span>
                                        }
                                    </Link>;
                            }
                        })
                    }
                    {Config.nextRacingEnabled && firstPathname && <NextRacing key={184} size="small" sportId={184} />}
                    {Config.nextRacingEnabled && firstPathname && <NextRacing key={31} size="small" sportId={31} />}
                </div>
            </div>
            <div className="right-column-t">
                <div className="nav-wrapper">
                    <LanguageSwitcher />
                    <div className="mini-naw-contain">
                        <ul>
                            {
                                pathName === "/casino" && <CasinoFavorites pathName={location.pathname} />
                            }
                            {
                                user.loggedIn && <li>
                                    <div className={`single-nav-item ${this.state.userInfo && "active"}`} onClick={this.setHandleClick("userInfo")}>
                                        <p>
                                            <i className="arrow-v-nav profile-v" />
                                        </p>
                                        <div className="open-d-view">
                                            <ul>
                                                <li>{t("User Name: {1}", userName)}</li>
                                                <li>{"Id: " + userId}</li>
                                                {
                                                    ((user.loggedInByRFID && Config.terminal.enableSignOutWithRfidButton) ||
                                                        (user.loggedIn && !user.loggedInByRFID)) &&
                                                    <li className="logout-v" onClick={this.logOut()}>{t("SIGN OUT")}</li>
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                </li>
                            }
                        </ul>
                    </div>
                    <div className="mini-naw-contain">
                        <ul>
                            <li className='search-in-header'>
                                {
                                    Config.searchInHeader && <SearchInHeader />
                                }
                            </li>
                            <li>
                                {Config.runtimeOddsFormatDropdow &&
                                    <div className='odds-format-container'>
                                        <span>{t("Odds Format")}</span>
                                        <OddsSelector />
                                    </div>
                                }
                            </li>
                            <li>
                                <Balance />
                            </li>
                            {
                                !user.loggedIn && <li>
                                    <div className="single-nav-item" onClick={this.props.openPopup("cashout")}>
                                        <p>{t("Cash out")}</p>
                                    </div>
                                </li>
                            }
                            {
                                !Config.terminal.disableTicket && <li onClick={this.props.openPopup("ticketInManualCheck")}>
                                    <div className="single-nav-item">
                                        <button className="button-view-t">{t("TICKET")}</button>
                                    </div>
                                </li>
                            }
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>;
}
